import React, {useEffect, useState} from "react";
import Grid from "@mui/material/Grid2";
import RayaField from "./RayaField";

const EditableJsonComponent = ({ initialJson,setResult }) => {
    // State to hold the JSON data
    const [jsonData, setJsonData] = useState(typeof initialJson === 'string' ? JSON.parse(initialJson) : JSON.parse(JSON.stringify(initialJson)));

    // Function to handle changes in the input fields
    const handleChange = (path, value) => {
        // Create a deep copy of the JSON data
        const updatedJson = JSON.parse(JSON.stringify(jsonData));

        // Traverse the path and update the value
        const keys = path.split(".");
        let current = updatedJson;
        for (let i = 0; i < keys.length - 1; i++) {
            current = current[keys[i]];
        }
        current[keys[keys.length - 1]] = value;

        // Update the state with the new JSON
        setJsonData(updatedJson);
    };
    useEffect(() => {
        setResult(jsonData)
    }, [jsonData]);
    // Recursive function to render editable fields for strings
    const renderEditableFields = (data, path = "") => {
        return Object.keys(data).map((key) => {
            const newPath = path ? `${path}.${key}` : key;
            if (typeof data[key] === "string") {
                return (
                    <Grid item size={12} key={newPath}>
                        <RayaField
                            fullWidth
                            label={key}
                            type="text"
                            value={data[key]}
                            onChange={(e) => handleChange(newPath, e.target.value)}
                        />
                    </Grid>
                );
            } else if (typeof data[key] === "object" && data[key] !== null) {
                return (
                    <div key={newPath}>
                        <strong>{key}:</strong>
                        {renderEditableFields(data[key], newPath)}
                    </div>
                );
            }
            return null;
        });
    };

    return (
        <Grid container spacing={2} style={{padding:20,backgroundColor:"#f5fdf4",borderRadius:12}}>
            {renderEditableFields(jsonData)}
        </Grid>
    );
};


export default EditableJsonComponent;